import { Directive } from "@angular/core";

/**
 * Used to display a hotkey action on a screen with consistent styling.
 * Provides badge-like appearance for keyboard shortcuts.
 *
 * @example
 * <mgd-hotkey-label>Ctrl+S</mgd-hotkey-label>
 * <span mgdHotkeyLabel>Ctrl+S</span>
 * <kbd mgdHotkeyLabel>Enter</kbd>
 */
@Directive({
    selector: "mgd-hotkey-label, [mgdHotkeyLabel]",
    host: {
        class: "mgd-hotkey-label"
    }
})
export class HotkeyLabelDirective {}
